"use client";

import { Inline, Link, PageHeader, Stack, Text } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import { styles } from "./policy-identity.styles";
import { PolicyIdentityDetails } from "./policy-identity-details";

export type PolicyVersionIdentityProps = {
  readonly layout?: "page" | "workspace";
  readonly label: string;
  readonly reference: string;
  readonly referenceAction?: ReactNode;
  readonly owner: ReactNode;
  readonly policyCreated: string;
  readonly versionCreated: string;
  readonly policyId: string;
  readonly versionId: string;
  readonly versionSelector: ReactNode;
  readonly back: { readonly href: string; readonly label: string };
};

export function PolicyVersionIdentity(props: PolicyVersionIdentityProps) {
  const entries = [
    { label: "Policy created", value: props.policyCreated },
    { label: "Version created", value: props.versionCreated },
    { label: "Policy ID", value: props.policyId },
    { label: "Version ID", value: props.versionId },
  ];
  return (
    <div {...stylex.props(styles.identity)}>
      <Stack width="auto">
        <PageHeader
          variant={props.layout}
          eyebrow="Policy"
          title={props.label}
          actions={
            <Inline>
              {props.versionSelector}
              <Link focus="native" href={props.back.href}>
                {props.back.label}
              </Link>
            </Inline>
          }
        />
        <Inline>
          <Text size="small" tone="muted">
            Owner
          </Text>
          {props.owner}
          {props.layout === "workspace" && (
            <>
              <Text size="small" tone="muted">
                Uploaded {props.versionCreated}
              </Text>
              {props.referenceAction}
            </>
          )}
        </Inline>
        {props.layout !== "workspace" && (
          <div>
            <Inline justify="between">
              <Text size="small" tone="muted">
                Policy reference
              </Text>
              {props.referenceAction}
            </Inline>
            <p {...stylex.props(styles.reference)}>{props.reference}</p>
          </div>
        )}
        <PolicyIdentityDetails
          layout={props.layout}
          reference={props.reference}
          entries={entries}
        />
      </Stack>
    </div>
  );
}
